export const SCROLL_OFFSET = 20;
export const CLICK_DISABLE_DURATION = 1500;
export const BOTTOM_PADDING_PER_ITEM = 75;
export const CHILD_ITEM_OFFSET = 10;
